import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShortLinkComponent } from './short-link.component';

@NgModule({
  declarations: [ShortLinkComponent],
  imports: [CommonModule]
})
export class ShortLinkModule {}
